import {defineAsyncComponent} from 'vue';

const ConfirmRedirectPopup = defineAsyncComponent(() => import('@/pages/ConfirmRedirectPopup.vue'));
const DevelopingPopup = defineAsyncComponent(() => import('@/pages/DevelopingPopup.vue'));
const ChangeBackgroundPopup = defineAsyncComponent(() => import('@/pages/ChangeBackgroundPopup.vue'));
const PlatformSetupWaitingPopup = defineAsyncComponent(() => import('@/pages/PlatformSetupWaitingPopup.vue'));
const SetupPromptPopup = defineAsyncComponent(() => import('@/pages/SetupPromptPopup.vue'));
const ResourcesLevelPopup = defineAsyncComponent(() => import('@/pages/ResourcesLevelPopup.vue'));
const GettingStartedPopup = defineAsyncComponent(() => import('@/pages/GettingStartedPopup.vue'));
const UpgradeGettingStartedPopup = defineAsyncComponent(() => import('@/pages/UpgradeGettingStartedPopup.vue'));
const IntroductionVideoPopup = defineAsyncComponent(() => import('@/pages/IntroductionVideoPopup.vue'));
const UpgradeSuccessPopup = defineAsyncComponent(() => import('@/pages/UpgradeSuccessPopup.vue'));
const UpgradeSuccessPopupiGov = defineAsyncComponent(() => import('@/pages/UpgradeSuccessPopupiGov.vue'));
const NotificationPopupiGov = defineAsyncComponent(() => import('@/pages/NotificationPopupiGov.vue'));
const CompleteSetupFinalConfirmPopup = defineAsyncComponent(() => import('@/pages/CompleteSetupFinalConfirmPopup.vue'));
const OrganizationSelectionPopup = defineAsyncComponent(() => import('@/pages/OrganizationSelectionPopup.vue'));
const OrganizationSyncDataPopup = defineAsyncComponent(() => import('@/pages/OrganizationSyncDataPopup.vue'));
const AppOrganizationSelectionPopup = defineAsyncComponent(() => import('@/pages/home/AppOrganizationSelectionPopup.vue'));
const PopupNoPermission = defineAsyncComponent(() => import('@/pages/PopupNoPermission.vue'));
const PopupExpired = defineAsyncComponent(() => import('@/pages/PopupExpired.vue'));
const UpgradeFailPopupiGov = defineAsyncComponent(() => import('@/pages/UpgradeFailPopupiGov.vue'));
const GettingStartedBanner = defineAsyncComponent(() => import('@/pages/GettingStartedBanner.vue'));
// [nvngoc1 - 2026-09-10] Thêm mới: popup thông báo hợp nhất đơn vị cho luồng getting started iGOV
const GettingStartedMergerBanner = defineAsyncComponent(() => import('@/pages/GettingStartedMergerBanner.vue'));
// [dkdien - 2026-09-17] Thêm mới: modal thông báo sáp nhập đơn vị hiển thị sau đăng nhập (PBI 752261)
const GettingStartedAcquisitionBanner = defineAsyncComponent(() => import('@/pages/GettingStartedAcquisitionBanner.vue'));
const UBNDCommuneGettingPopup = defineAsyncComponent(() => import('@/pages/UBNDCommuneGettingPopup.vue'));
export function registerCommonPopup(app) {
  app.component('ConfirmRedirectPopup', ConfirmRedirectPopup);
  app.component('DevelopingPopup', DevelopingPopup);
  app.component('ChangeBackgroundPopup', ChangeBackgroundPopup);
  app.component('PlatformSetupWaitingPopup', PlatformSetupWaitingPopup);
  app.component('SetupPromptPopup', SetupPromptPopup);
  app.component('ResourcesLevelPopup', ResourcesLevelPopup);
  app.component('GettingStartedPopup', GettingStartedPopup);
  app.component('UpgradeGettingStartedPopup', UpgradeGettingStartedPopup);
  app.component('IntroductionVideoPopup', IntroductionVideoPopup);
  app.component('UpgradeSuccessPopup', UpgradeSuccessPopup);
  app.component('UpgradeSuccessPopupiGov', UpgradeSuccessPopupiGov);
  app.component('NotificationPopupiGov', NotificationPopupiGov);
  app.component('CompleteSetupFinalConfirmPopup', CompleteSetupFinalConfirmPopup);
  app.component('OrganizationSelectionPopup', OrganizationSelectionPopup);
  app.component('OrganizationSyncDataPopup', OrganizationSyncDataPopup);
  app.component('AppOrganizationSelectionPopup', AppOrganizationSelectionPopup);
  app.component('PopupNoPermission', PopupNoPermission);
  app.component('PopupExpired', PopupExpired);
  app.component('UpgradeFailPopupiGov', UpgradeFailPopupiGov);
  app.component('GettingStartedBanner', GettingStartedBanner);
  app.component('GettingStartedMergerBanner', GettingStartedMergerBanner);
  app.component('GettingStartedAcquisitionBanner', GettingStartedAcquisitionBanner);
  app.component('UBNDCommuneGettingPopup', UBNDCommuneGettingPopup);
}
